
    import './styles.scoped.css';
    export default {
  "expandable-toggle-wrapper": "awsui_expandable-toggle-wrapper_c6tup_fo032_99",
  "body-cell": "awsui_body-cell_c6tup_fo032_107",
  "body-cell-content": "awsui_body-cell-content_c6tup_fo032_121",
  "body-cell-wrap": "awsui_body-cell-wrap_c6tup_fo032_124",
  "is-visual-refresh": "awsui_is-visual-refresh_c6tup_fo032_136",
  "has-striped-rows": "awsui_has-striped-rows_c6tup_fo032_148",
  "expandable-level-0": "awsui_expandable-level-0_c6tup_fo032_151",
  "expandable-level-1": "awsui_expandable-level-1_c6tup_fo032_154",
  "expandable-level-2": "awsui_expandable-level-2_c6tup_fo032_157",
  "expandable-level-3": "awsui_expandable-level-3_c6tup_fo032_160",
  "expandable-level-4": "awsui_expandable-level-4_c6tup_fo032_163",
  "expandable-level-5": "awsui_expandable-level-5_c6tup_fo032_166",
  "expandable-level-6": "awsui_expandable-level-6_c6tup_fo032_169",
  "expandable-level-7": "awsui_expandable-level-7_c6tup_fo032_172",
  "expandable-level-8": "awsui_expandable-level-8_c6tup_fo032_175",
  "expandable-level-9": "awsui_expandable-level-9_c6tup_fo032_178",
  "expandable-level-next": "awsui_expandable-level-next_c6tup_fo032_181",
  "body-cell-edit-active": "awsui_body-cell-edit-active_c6tup_fo032_184",
  "body-cell-interactive": "awsui_body-cell-interactive_c6tup_fo032_184",
  "body-cell-editable": "awsui_body-cell-editable_c6tup_fo032_184",
  "has-striped-rows-sticky-cell-pad-inline-start": "awsui_has-striped-rows-sticky-cell-pad-inline-start_c6tup_fo032_256",
  "has-selection": "awsui_has-selection_c6tup_fo032_292",
  "body-cell-first-row": "awsui_body-cell-first-row_c6tup_fo032_331",
  "body-cell-last-row": "awsui_body-cell-last-row_c6tup_fo032_334",
  "body-cell-selected": "awsui_body-cell-selected_c6tup_fo032_334",
  "has-footer": "awsui_has-footer_c6tup_fo032_334",
  "body-cell-shaded": "awsui_body-cell-shaded_c6tup_fo032_344",
  "sticky-cell": "awsui_sticky-cell_c6tup_fo032_370",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_c6tup_fo032_378",
  "sticky-cell-last-inline-end": "awsui_sticky-cell-last-inline-end_c6tup_fo032_428",
  "sticky-cell-last-inline-start": "awsui_sticky-cell-last-inline-start_c6tup_fo032_436",
  "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_fo032_467",
  "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_fo032_471",
  "body-cell-editor-wrapper": "awsui_body-cell-editor-wrapper_c6tup_fo032_495",
  "body-cell-success": "awsui_body-cell-success_c6tup_fo032_502",
  "body-cell-editor": "awsui_body-cell-editor_c6tup_fo032_495",
  "body-cell-editor-disabled": "awsui_body-cell-editor-disabled_c6tup_fo032_529",
  "body-cell-editor-form": "awsui_body-cell-editor-form_c6tup_fo032_538",
  "body-cell-editor-row": "awsui_body-cell-editor-row_c6tup_fo032_548",
  "body-cell-editor-controls": "awsui_body-cell-editor-controls_c6tup_fo032_558",
  "body-cell-expandable": "awsui_body-cell-expandable_c6tup_fo032_561",
  "resizable-columns": "awsui_resizable-columns_c6tup_fo032_582",
  "expandable-cell-content": "awsui_expandable-cell-content_c6tup_fo032_585",
  "body-cell-edit-disabled-popover": "awsui_body-cell-edit-disabled-popover_c6tup_fo032_633",
  "body-cell-has-success": "awsui_body-cell-has-success_c6tup_fo032_636"
};
  